import { render, staticRenderFns } from "./BigList.vue?vue&type=template&id=83d2174a&"
import script from "./BigList.vue?vue&type=script&lang=js&"
export * from "./BigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports